import { useState } from "react";
import { Link, Outlet } from "react-router-dom";

function MainLayout() {
    const [title, setTitle] = useState('');

    return(
        <>
            <div className="sm:container m-auto p-10 text-lg">
                <div>
                    <header className="flex justify-between items-center">
                        <h1 className="text-4xl">{title}</h1>
                    </header>
                </div>
                <div className="pb-[150px]">
                    <Outlet context={{ title, setTitle }}/>
                </div>
            </div>
            <div className="w-screen shadow-[2px_14px_20px_3px_rgba(0,0,0,0.25)]  fixed bottom-0 bg-white">
                <nav className="divide-solid flex justify-around text-gray-700">
                    <LinkNav to="/" title="Beranda" active={title === 'Catatan Sembako' && true}>
                        <div>
                            <svg style={{margin:'auto'}} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" 
                                stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" 
                                class="icon icon-tabler icons-tabler-outline icon-tabler-home"><path stroke="none" d="M0 0h24v24H0z" 
                                fill="none"/><path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                                <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                                <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" /></svg>
                        </div>
                    </LinkNav>
                    <LinkNav to="/cari-saham" title="Cari" active={title === 'Cari Saham' && true}>
                        <div>
                            <svg style={{margin:'auto'}} className="m-auto" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" 
                                fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" 
                                class="icon icon-tabler icons-tabler-outline icon-tabler-search"><path stroke="none" 
                                d="M0 0h24v24H0z" fill="none"/><path d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                <path d="M21 21l-6 -6" /></svg>
                        </div>
                    </LinkNav>
                    <LinkNav to="/setor" title="Setor" active={title === 'Setor Saham' && true}>
                        <div>
                            <svg style={{margin:'auto'}}  xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" 
                                fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" 
                                stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-cash-plus">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
                                <path d="M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2.5" />
                                <path d="M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M16 19h6" />
                                <path d="M19 16v6" /></svg>
                        </div>
                    </LinkNav>
                    <LinkNav to="/add-saham" title="+ Tambah" active={title === 'Tambah Saham' && true}>
                        <div>
                            <svg style={{margin:'auto'}}  xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" 
                                fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" 
                                stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-cash-plus">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
                                <path d="M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2.5" />
                                <path d="M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M16 19h6" />
                                <path d="M19 16v6" /></svg>
                        </div>
                    </LinkNav>
                </nav>
            </div>
        </>
    )
}

function LinkNav(props) {
    return(
        <Link to={props.to}  className={`text-xl pt-5 pb-5 border-gray-100 flex flex-col justify-center ${props.active && 'text-[#8570FF]'}`}>
            {props.children}
            <span className="text-md block mt-5">{props.title}</span>
        </Link>
    )
}

export default MainLayout;